import 'style/index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { RootApplication } from './app';

ReactDOM.render(<RootApplication />, document.getElementById('root'));